import React, { useState, useEffect } from "react";
import PasswordSetModal from "../../../../components/modals/PasswordSetModal";
import privateAxios from "../../../../utils/axiosPrivate";
import { system_control } from "../../../../utils/data/data";
import { showToast } from "../../../../utils/utils";
import { useParams } from "react-router-dom";
import { showToastType } from "../../../../utils/constants/appConstants";
import { customerTab } from "../../../../locales/en";
import { useSelector, useDispatch } from "react-redux";
import styles from "./../../../../assets/scss/custom.module.scss";
import { getPasswordConfirmation } from "../../../../redux/invoiceDetailsSlice";
import { getUserManagementsystemSettingsUrl } from "../../../../utils/constants/apiEndPoints";
const SystemControl = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { usersData } = useSelector((state) => state.userManagement);

  const initialCombineData = {
    skipApplicationProcess: "",
    forceApplicationProcess: "",
    enableCfbMenu: "",
    invoiceUpload: "",
    pastInvoiceDueDate: "",
    pastInvoiceAmmount: "",
    rebootInvoiceSync: "",
    writeBackToXeroAndMYOB: "",
    paymentProofRequired: ""
  };
  const [combineData, setCombineData] = useState(initialCombineData);

  useEffect(() => {
    if (usersData && usersData.systemSettings) {
      setCombineData(usersData.systemSettings);
    }
  }, [usersData]);

  const handleDropDownChange = async (event) => {
    const { name, value } = event.target;
    setCombineData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));

    try {
      const key = name;
      const keyValue = value;
      let url;
      if (key === "paymentProofRequired") {
        url = `${getUserManagementsystemSettingsUrl(id)}?key=${encodeURIComponent(key)}&value=${encodeURIComponent(keyValue)}&isPaymentProofSystemGenerated=${false}`;
      } else {
        url = `${getUserManagementsystemSettingsUrl(id)}?key=${encodeURIComponent(key)}&value=${encodeURIComponent(keyValue)}`;
      }

      const response = await privateAxios.patch(url);
      showToast(response?.data?.message, showToastType.success);
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    }
  };

  // const handleALertPopup = async (event) => {
  //   const { name, value } = event.target;
  //   const result = await showAlert(
  //     "",
  //     `${customerTab.systemControl.errMsg.item1} ${
  //       value === "true"
  //         ? customerTab.systemControl.enable.item1
  //         : customerTab.systemControl.disable
  //     } ${customerTab.systemControl.errMsg.item2}`,
  //     "",
  //     alertActions.Confirm,
  //     alertActions.Cancel
  //   );

  //   if (result.isConfirmed) {
  //     try {
  //       setCombineData((prevFormData) => ({
  //         ...prevFormData,
  //         [name]: value
  //       }));

  //       const response = await privateAxios.patch(
  //         `${getUserManagementsystemSettingsUrl(id)}?key=${encodeURIComponent(
  //           name
  //         )}&value=${encodeURIComponent(value)}`
  //       );

  //       if (response.status === 200) {
  //         showToast(response.data.message, showToastType.success);
  //       }
  //     } catch (error) {
  //       showToast(error?.response?.data?.message, showToastType.error);
  //     }
  //   }
  // };

  // Password Verify Function
  const [addPasswordModal, setAddPasswordModal] = useState(false);

  const handleModalClose = () => {
    setAddPasswordModal(false);
  };

  const handlePendingInvoiceUpdate = async ({ name, value }) => {
    try {
      setCombineData((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));

      const response = await privateAxios.patch(
        `${getUserManagementsystemSettingsUrl(id)}?key=${encodeURIComponent(name)}&value=${encodeURIComponent(value)}`
      );

      if (response.status === 200 || response.status === 201) {
        showToast(response.data.message, showToastType.success);
      }
    } catch (error) {
      showToast(
        error.response?.data?.errors || error.message,
        showToastType.error
      );
    }
  };

  // const handleALertPastInvoiceAmmount = (event) => {
  //   const { name, value } = event.target;
  //   const prevValue = combineData[name];
  //   showAlert(
  //     "",
  //     `${customerTab.systemControl.errMsg.item3} ${
  //       value === "true"
  //         ? customerTab.systemControl.enabling
  //         : customerTab.systemControl.disabling
  //     } ${customerTab.systemControl.errMsg.item4}`,
  //     "",
  //     alertActions.Confirm,
  //     alertActions.Cancel
  //   ).then((result) => {
  //     if (result.isConfirmed) {
  //       setAddPasswordModal(true);
  //       setCombineData((prevData) => ({
  //         ...prevData,
  //         tempName: name,
  //         tempValue: value,
  //         [name]: value
  //       }));
  //     } else {
  //       setCombineData((prevData) => ({
  //         ...prevData,
  //         [name]: prevValue
  //       }));
  //     }
  //   });
  // };

  const handlePasswordEntered = async (password) => {
    try {
      const dataToSend = { password };
      const response = await dispatch(
        getPasswordConfirmation(dataToSend)
      ).unwrap();

      if (response.status === 200 || response.status === 201) {
        setAddPasswordModal(false);

        setCombineData((prevFormData) => {
          const { tempName, tempValue } = prevFormData;
          if (tempName !== undefined && tempValue !== undefined) {
            handlePendingInvoiceUpdate({ name: tempName, value: tempValue });
          }
          return {
            ...prevFormData,
            tempName: undefined,
            tempValue: undefined
          };
        });
      }
    } catch {
      // for catch here
    }
  };

  const getSystemControlData = () => {
    return system_control?.map((orgtype, index) => (
      <option key={index} value={orgtype.value}>
        {orgtype.name}
      </option>
    ));
  };

  return (
    <>
      <div>
        <div className={styles.titleArea}>
          <h5>{customerTab?.systemControl.title}</h5>
        </div>
        <div className="row">
          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.skipAppProcss}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleDropDownChange}
                name="skipApplicationProcess"
                value={combineData.skipApplicationProcess ?? ""}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>

          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.forceAppProcss}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleDropDownChange}
                name="forceApplicationProcess"
                value={combineData.forceApplicationProcess ?? ""}
              >
                {system_control?.map((orgtype, index) => (
                  <option key={index} value={orgtype.value}>
                    {orgtype.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.enableCfb}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleALertPopup}
                name="enableCfbMenu"
                value={combineData.enableCfbMenu}
              >
                {system_control.map((orgtype, index) => (
                  <option key={index} value={orgtype.value}>
                    {orgtype.name}
                  </option>
                ))}
              </select>
            </div>
          </div> */}

          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.invcsUpload}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleDropDownChange}
                name="invoiceUpload"
                value={combineData.invoiceUpload ?? ""}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>

          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.pastInvcDate}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleDropDownChange}
                name="pastInvoiceDueDate"
                value={combineData.pastInvoiceDueDate ?? ""}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>

          {/* <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.pastInvcAmmnt}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleALertPastInvoiceAmmount}
                name="pastInvoiceAmmount"
                value={combineData.pastInvoiceAmmount}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div> */}

          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.rebootIncsSync}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                onChange={handleDropDownChange}
                name="rebootInvoiceSync"
                value={combineData.rebootInvoiceSync ?? ""}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>
          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.accWriteBack}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                name="writeBackToXeroAndMYOB"
                value={combineData.writeBackToXeroAndMYOB ?? ""}
                onChange={handleDropDownChange}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>
          <div className="col-12 col-xxl-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.systemControl.proofOfPayment}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                name="paymentProofRequired"
                value={combineData.paymentProofRequired ?? ""}
                onChange={handleDropDownChange}
              >
                {getSystemControlData()}
              </select>
            </div>
          </div>
        </div>
      </div>
      <PasswordSetModal
        isOpen={addPasswordModal}
        toggle={handleModalClose}
        handlePasswordEntered={handlePasswordEntered}
      />
    </>
  );
};
export default SystemControl;
